export const ROUTES = {
  BLOGS: "/blogs",
  CONFIRM_REGISTRATION: "/confirm-registration",
  DEVICES: "/devices",
  LOGIN: "/login",
  NOT_FOUND: "*",
  PASSWORD_RECOVERY: "/password-recovery",
  POST_DETAIL: "/posts/:postId",
  POSTS: "/posts",
  ROOT: "/",
  SIGNUP: "/signup",
  USERS: "/users",
  VIDEOS: "/videos",
} as const;
